<div class="location-title">
  <fa-icon [icon]="locationIcon" [fixedWidth]="true"></fa-icon>
  <span>{{ location.name }}</span>
</div>
<ng-container [ngSwitch]="location.type" class="location-details">
  <ng-container *ngSwitchCase="IlLocationTypeEnum.IlOnlineLocation">
    <ng-container *ngIf="!stateMessage; else messageTemplate">
      <vnm-external-link *ngIf="!hideLocationUrl" [url]="location?.url"></vnm-external-link>
    </ng-container>
  </ng-container>
  <vnm-address *ngSwitchCase="IlLocationTypeEnum.IlPhysicalLocation" [address]="location?.address"></vnm-address>
  <vnm-empty-message *ngSwitchDefault></vnm-empty-message>
</ng-container>

<ng-template #messageTemplate>
  <span class="state-message">{{ stateMessage | translate }}</span>
</ng-template>
